import React from 'react';
import { GiftIcon, BookOpenIcon } from 'lucide-react';
import { stack, price } from '../data/landing';
export function ValueStack() {
  return <section className="w-full bg-plum-deep text-cream" aria-labelledby="oferta-titulo" data-id="element-113" data-mp="249fgz9tpqvne">
      <div className="mx-auto max-w-content px-6 py-16 md:py-24" data-id="element-114" data-mp="1q9xnih5h2u7p">
        <div className="max-w-2xl" data-id="element-115" data-mp="1u96fphkv6k15">
          <h2 id="oferta-titulo" className="font-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-116" data-mp="1ua838lj2gyzr">
            Todo lo que desbloqueás hoy
          </h2>
          <p className="mt-4 font-sans text-lg text-cream/70" data-id="element-117" data-mp="2mxu59pcnbvki">
            Al adquirir el Kit accedés al arsenal completo del Terapeuta Pro.
          </p>
        </div>

        <ul className="mt-12 space-y-3" data-id="element-118" data-mp="2d7r2ixfq338z">
          {stack.map(item => <li key={item.name} className={`flex flex-wrap items-baseline gap-x-4 gap-y-2 rounded-xl px-5 py-5 sm:flex-nowrap ${item.isCore ? 'bg-clay/15 ring-1 ring-clay/40' : 'bg-plum-soft/50'}`} data-id="element-119" data-mp="30ymze8z1con3">
              <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${item.isCore ? 'bg-clay text-cream' : 'bg-cream/10 text-sand'}`} data-id="element-120" data-mp="1ogs4dkz5jyia">
                {item.isCore ? <BookOpenIcon aria-hidden="true" className="h-4 w-4" data-id="element-121" data-mp="1ycmsuwq24nsz" /> : <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-122" data-mp="2c7p8wcombtji" />}
              </span>

              <div className="min-w-0 grow" data-id="element-123" data-mp="286lwk05s4fn1">
                <p className="font-sans text-xs uppercase tracking-wider text-sand/60" data-id="element-124" data-mp="2m2zch4uo08ze">
                  {item.label}
                </p>
                <h3 className={`mt-1 font-display font-semibold leading-snug ${item.isCore ? 'text-xl sm:text-2xl' : 'text-lg'}`} data-id="element-125" data-mp="2h2urp2mq4s3d">
                  {item.name}
                </h3>
                {item.detail ? <p className="mt-1 font-sans text-sm text-cream/60" data-id="element-126" data-mp="2mv0j8j9ayl2f">
                    {item.detail}
                  </p> : null}
              </div>

              <p className="ml-auto shrink-0 font-sans text-base text-cream/70" data-id="element-127" data-mp="2vt2o59w5pxuz">
                Valor:{' '}
                <span className="font-semibold text-cream" data-id="element-128" data-mp="30ui9l328y6dw">{item.value}</span>
              </p>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-wrap items-baseline justify-between gap-4 border-t border-cream/15 pt-6" data-id="element-129" data-mp="35q79x8m3brb9">
          <p className="font-display text-xl font-semibold text-cream" data-id="element-130" data-mp="3fi3cavv7m3la">
            Valor total del arsenal
          </p>
          <p className="font-display text-3xl font-semibold text-sand line-through decoration-clay decoration-2" data-id="element-131" data-mp="3jjokw50pnvpo">
            {price.total} {price.currency}
          </p>
        </div>
      </div>
    </section>;
}